'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  }

  $onInit() {
    this.getBookList();
  }

  getBookList() {
    this.$http.get('/api/booklists').then(res => {
      this.books = res.data.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete(`/api/booklists/${id}`).then(res => {
        this.getBookList();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/booklist/list/list.controller.js